export default {
    // 账号：便携式驱蚊棒项目
    // 密码：Thzip@8888
    // apiUrl: 'http://192.168.0.199:1114',    // 本地
    // apiUrl: 'https://trace.thzip.com',   // 线上
    apiUrl : `${location.origin}`,   // 自动获取
}